import { useState } from "react";
import { TrendingUp, ChevronDown } from "lucide-react";
import { PHASES } from "@/lib/lunelle-data";
import { symptomInsights } from "@/lib/cycle";
import { SYMPTOM_TIPS } from "@/lib/symptom-tips";

const PHASE = Object.fromEntries(PHASES.map((p) => [p.id, p]));
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");
const range = (lo, hi) => (lo === hi ? `day ${lo}` : `days ${lo}–${hi}`);

const InsightRow = ({ s }) => {
  const [open, setOpen] = useState(false);
  const p = PHASE[s.phase];
  const tip = SYMPTOM_TIPS[s.name];
  return (
    <li className="border-t border-[#C86D51]/15 py-3 first:border-t-0" data-testid={`insight-${slug(s.name)}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center gap-3 text-left" data-testid={`insight-toggle-${slug(s.name)}`}>
        <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: p.color }} />
        <span className="flex-1 text-sm text-[#2C221E]">
          <b>{s.name}</b> usually on {range(s.lo, s.hi)} <span className="text-[#6B5A52]">· {p.name} · logged {s.count}×</span>
        </span>
        {tip && <ChevronDown className={`h-4 w-4 shrink-0 text-[#9E4429] transition-transform duration-300 ${open ? "rotate-180" : ""}`} />}
      </button>
      {open && tip && (
        <div className="mt-2 pl-5 text-sm leading-relaxed text-[#3D302B]">
          <p>{tip.tip}</p>
          {tip.doctor && <p className="mt-1.5 text-xs text-[#6B5A52]">{tip.doctor}</p>}
        </div>
      )}
    </li>
  );
};

export const SymptomInsights = ({ cycle }) => {
  const list = symptomInsights(cycle);
  return (
    <div className="mt-8 rounded-[1.5rem] border border-[#C86D51]/15 bg-white/60 p-5" data-testid="symptom-insights">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#9E4429]"><TrendingUp className="h-4 w-4" /> Your symptom patterns</p>
      {list.length ? (
        <>
          <ul className="mt-3">{list.slice(0, 6).map((s) => <InsightRow key={s.name} s={s} />)}</ul>
          <p className="mt-2 text-xs text-[#6B5A52]">Patterns get sharper the more cycles you log. Tap a symptom for tips.</p>
        </>
      ) : (
        <p className="mt-3 text-sm text-[#5C4A42]" data-testid="symptom-insights-empty">Log symptoms on a few days and Lunelle will show when they usually show up, plus tips that may help.</p>
      )}
    </div>
  );
};
